const sizeStyle = (size, direction)=>{
    if (direction === 'left' || direction === 'right') {
        switch(size){
            case 'full':
                return 'w-full h-full';
            case 'half':
                return 'w-1/2 h-full';
            case 'third':
                return 'w-1/3 h-full';
            default:
                return 'w-1/4 h-full';
        }
    } else {
        switch(size){
            case 'full':
                return 'h-full w-full';
            case 'half':
                return 'h-1/2 w-full';
            case 'third':
                return 'h-1/3 w-full';
            default:
                return 'h-1/4 w-full';
        }
    }
};
const directionStyle = {
    left: 'left-0 top-0 transform -translate-x-full',
    right: 'right-0 top-0 transform translate-x-full',
    top: 'top-0 left-0 transform -translate-y-full',
    bottom: 'bottom-0 left-0 transform translate-y-full'
};
const openStyle = {
    left: 'translate-x-0',
    right: 'translate-x-0',
    top: 'translate-y-0',
    bottom: 'translate-y-0'
};

export { directionStyle, openStyle, sizeStyle };
